const MONTHS = 12;

export const FINANCIAL_INCOME_KEY = 'Ingresos (Ventas y Renovaciones)';
export const FINANCIAL_EXPENSE_KEYS = [
  'Cuentas', 'Empleados', 'Licencias', 'Publicidad',
  'Retiro Fondo de Reserva', 'Membresías', 'Otros'
];
export const FINANCIAL_PARTNER_KEYS = ['Jose Aguilar', 'Willer Escalona'];

export const emptyMonthlyValues = () => Array(MONTHS).fill(0);

/** Returns an initialized canonical financial matrix safe for monthly writes. */
export const createFinancialMatrix = () => ({
  ingresos: { [FINANCIAL_INCOME_KEY]: emptyMonthlyValues() },
  gastos: Object.fromEntries(FINANCIAL_EXPENSE_KEYS.map(key => [key, emptyMonthlyValues()])),
  retiros: Object.fromEntries(FINANCIAL_PARTNER_KEYS.map(key => [key, emptyMonthlyValues()])),
  totalIngresos: emptyMonthlyValues(),
  totalGastos: emptyMonthlyValues(),
  totalRetiros: emptyMonthlyValues(),
  utilidadNeta: emptyMonthlyValues(),
  fondoReserva: emptyMonthlyValues(),
  fondoPublicidad: emptyMonthlyValues()
});

/** Guarantees a monthly array exists before an indexed assignment. */
export const ensureMonthlyValues = (target, key) => {
  if (!target[key]) target[key] = emptyMonthlyValues();
  return target[key];
};

export const roundFinancialAmount = (value) => Number((Number(value) || 0).toFixed(2));

const textIncludesBolivares = (value) => /\bBs\b|\[\s*Bs\s*\]|bol[ií]var|pago\s*m[oó]vil|transferencia/i.test(String(value || ''));

/**
 * Converts a financial movement to USD. It accepts legacy Firebase records where
 * a bolivar amount was mistakenly persisted in monto/amount without conversion.
 */
export const movementAmountUsd = (movement = {}, fallbackRate = 0) => {
  const amount = Number(movement.amount ?? movement.monto ?? movement.total ?? 0) || 0;
  const currency = movement.currency ?? movement.moneda ?? movement.simbolo;
  const paymentMethod = movement.metodo_pago ?? movement.metodo ?? movement.forma_pago ?? movement.categoria_pago;
  const isBolivares = textIncludesBolivares(currency) || textIncludesBolivares(paymentMethod);
  if (!isBolivares) return roundFinancialAmount(amount);

  const rate = Number(movement.tasa ?? movement.rate ?? movement.exchange_rate ?? fallbackRate);
  return rate > 0 ? roundFinancialAmount(amount / rate) : 0;
};

export const isOperatingExpense = (category) => category !== 'Publicidad';

